import { Skeleton } from '@mui/material';
import { useGetTableColumnsList } from '../api/dataCatalog/getTableColumns';
import Checkbox from '@/components/Checkbox';

export const EditColList = ({
  table,
  selected,
  setSelected,
  selectedColDetails,
  searchQuery,
}) => {
  const columnListData = useGetTableColumnsList({
    tableId: table.id,
    keyword: searchQuery,
    config: {
      // staleTime: Infinity,
    },
  });

  return (
    <div
      className="flex flex-col bg-white p-2 rounded-lg border border-pv-neutral-grey-100"
      style={{
        width: '300px',
        maxHeight: '180px',
        overflowY: 'auto',
        boxShadow: '0 0 25px -15px black',
      }}
    >
      {columnListData.isLoading ? (
        Array.from({ length: 5 }).map((_, index) => (
          <div className="flex gap-2 p-2" key={index}>
            <Skeleton
              variant="rounded"
              width={index % 2 === 1 ? '35%' : '65%'}
              height={20}
              sx={{ bgcolor: '#EEF0F7' }}
            />
          </div>
        ))
      ) : columnListData.data?.data?.length > 0 ? (
        columnListData.data.data.map((col, ind) => {
          return (
            <Checkbox
              label={col.name}
              key={ind}
              checked={
                selected.findIndex(
                  (sel) =>
                    sel.tableId === table.id && sel.foreignField === col.name
                ) > -1
              }
              className={{
                wrapper:
                  'px-4 py-3 w-full flex gap-2 items-center hover:bg-pv-primary-primary-50 cursor-pointer',
                label: 'max-w-56 overflow-hidden overflow-ellipsis',
              }}
              onChange={(e) => {
                if (e.checked) {
                  setSelected((prev) => {
                    let temp = structuredClone(prev);
                    temp.push({
                      localField: selectedColDetails.name,
                      foreignField: col.name,
                      table: table.name,
                      tableId: table.id,
                    });
                    temp.sort((a, b) => {
                      const str1 = a.foreignField + a.table;
                      const str2 = b.foreignField + b.table;
                      return str1.localeCompare(str2);
                    });
                    return temp;
                  });
                } else {
                  setSelected((prev) => {
                    let temp = structuredClone(prev);
                    temp = temp.filter(
                      (tmp) =>
                        !(
                          tmp.tableId === table.id &&
                          tmp.foreignField === col.name
                        )
                    );
                    temp.sort((a, b) => {
                      const str1 = a.foreignField + a.table;
                      const str2 = b.foreignField + b.table;
                      return str1.localeCompare(str2);
                    });
                    return temp;
                  });
                }
              }}
            />
          );
        })
      ) : (
        <span className="text-pv-text-secondary-text p-1">
          No columns found
        </span>
      )}
    </div>
  );
};
